import {TOGGLE_MENU} from './constants'

// Initial State
import initialState from './initialState'

// Utils
import createReducer from 'fc-utils/createReducer'

export function toggleMenu (state) {
  return {
    ...state,
    toggled: !state.toggled,
  }
}

export default createReducer(initialState, {
  [TOGGLE_MENU]: toggleMenu,
})
